import React, { Component } from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import styled from 'styled-components';

const Chartdiv = styled.div`
  width: 50%;
  height: 300px;

  @media (max-width: 1680px) {

  }
`;

class OrdersChart extends Component {

  constructor(props) {
    super(props);

    this.chartDiv = React.createRef();
  }

  componentDidMount () {
    const { history } = this.props;

    let chart = AmCharts.makeChart( this.chartDiv, {
      "type": "stock",
      "theme": "none",
      "dataSets": [ {
        "title": "open",
        "fieldMappings": [ {
          "fromField": "open",
          "toField": "open"
        }, {
          "fromField": "volume",
          "toField": "volume"
        } ],
        "color": "#509dde",
        "dataProvider": history,
        "categoryField": "trading_date"
      }
      ],
      "categoryAxesSettings": {
        "inside": false,
        "showLastLabel": true,
        "showFirstLabel": false,
        //"gridColor": '#',
      },
      "valueAxesSettings": {
        "unitPosition": "left",
        "inside": false,
        "showLastLabel": true,
        "showFirstLabel": false,
        //"gridColor": '#ffffff',
      },
      "panelsSettings": {
        "marginLeft": 50,
        "marginTop": 20,
        "marginRight": 10,
        "panelSpacing": 0,
        "usePrefixes": true,
        "prefixesOfBigNumbers":[{number:1e+3,prefix:"K"},
          {number:1e+6,prefix:"M"},
          {number:1e+9,prefix:"B"},
          {number:1e+12,prefix:"T"},
          {number:1e+15,prefix:"P"},
          {number:1e+18,prefix:"E"},
          {number:1e+21,prefix:"Z"},
          {number:1e+24,prefix:"Y"}],
      },
      "panels": [ {
        "showCategoryAxis": false,
        "title": "Value",
        //"color": "white",
        "percentHeight": 60,
        "stockGraphs": [ {
          "id": "g1",
          "showBalloon": true,
          "valueField": "open",
          "comparable": true,
          "compareField": "open",
          "balloonText": "[[title]]: $<b>[[value]]</b>",
          "compareGraphBalloonText": "[[title]]:<b>[[value]]</b>"
        } ]
      }, {
        "title": "Volume",
        //"color": "white",
        "percentHeight": 40,
        "stockGraphs": [ {
          "valueField": "volume",
          "type": "column",
          "showBalloon": true,
          "fillAlphas": 1,
        } ]
      } ],

      "chartScrollbarSettings": {
        "enabled": false,
      },

      "periodSelector": {
        "position": "bottom",
        "dateFormat": "DD MMM, YYYY",
        "inputFieldsEnabled": false,
        "periods": [ {
          "period": "DD",
          "selected": true,
          "count": 14,
          "label": "14 Days"
        }, {
          "period": "MM",
          "count": 1,
          "label": "1 Month"
        }, {
          "period": "MM",
          "count": 3,
          "label": "3 Months"
        }, {
          "period": "YYYY",
          "count": 1,
          "label": "1 Year"
        }, {
          "period": "MAX",
          "label": "All"
        }]
      },

      "chartCursorSettings": {
        "categoryBalloonDateFormats": [{period:"YYYY", format:"YYYY"},
          {period:"MM", format:"MMM, YYYY"},
          {period:"WW", format:"DD MMM, YYYY"},
          {period:"DD", format:"DD MMM, YYYY"},
          {period:"hh", format:"JJ:NN"},
          {period:"mm", format:"JJ:NN"},
          {period:"ss", format:"JJ:NN:SS"},
          {period:"fff", format:"JJ:NN:SS"}],
        "valueBalloonsEnabled": true,
        "fullWidth": true,
        "cursorAlpha": 0.1,
        "valueLineBalloonEnabled": false,
        "valueLineEnabled": true,
        "valueLineAlpha": 0.8
      },

      "export": {
        "enabled": false
      }
    });

    this.chart = chart;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (nextProps.history.length) {
      const { history } = nextProps;

      this.chart.dataSets[0].dataProvider = history;
      this.chart.validateData();
    }
  }

  render() {
    return <Chartdiv><div className="chartDiv" style={{height: '100%'}} ref={(ref) => this.chartDiv = ref} /></Chartdiv>
  }
}

export default OrdersChart;